


























































































































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Faction, Resource as ResourceEnum } from "@gaia-project/engine";
import Building from "./Building.vue";
import Qic from "./Resources/Qic.vue";
import VictoryPoint from "./Resources/VictoryPoint.vue";
import Federation from "./FederationTile.vue";
import Token from "./Token.vue";

@Component({
  components: {
    Building,
    Federation,
    Qic,
    Token,
    VictoryPoint,
  },
})
export default class Resource extends Vue {
  @Prop()
  kind: ResourceEnum;

  @Prop()
  count: number;

  @Prop({ default: false })
  centerLeft: boolean;

  @Prop({ default: "gen" })
  faction: Faction;

  @Prop()
  tooltip: string;

  get flat() {
    return this.$store.state.preferences.flatBuildings;
  }
}
